import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PosProfileFormWrapperComponent } from '../components/pos-profile-form-wrapper/pos-profile-form-wrapper.component';
import { 
  PosProfileFormConfig,
  getPosProfileFormConfig
} from '../pos-profile.config';
import { PosProfileService } from '../services/pos-profile.service';

@Component({
  selector: 'app-pos-profile-view',
  standalone: true,
  imports: [PosProfileFormWrapperComponent],
  templateUrl: './pos-profile-view.component.html',
  styleUrls: ['./pos-profile-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosProfileViewComponent {
  private posProfileService = inject(PosProfileService);
  
  config: PosProfileFormConfig = {
    ...getPosProfileFormConfig(this.posProfileService),
    title: 'pos.form.view_pos_terminal'
  };
}
